var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSend(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 512,
    viewBox: "0 0 32 32",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m26.731 5.269a.912.912 0 0 0 -.938-.221l-20.166 6.722a.916.916 0 0 0 .062 1.757l10.17 2.615 2.614 10.17a.918.918 0 0 0 .856.687h.032a.918.918 0 0 0 .87-.627l6.721-20.165a.917.917 0 0 0 -.221-.938zm-7.256 17.575-1.975-7.683a.915.915 0 0 0 -.659-.66l-7.684-1.976 15.477-5.159z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSend);
export default __webpack_public_path__ + "static/media/send.60136b5455324877ef9cfbf05c568171.svg";
export { ForwardRef as ReactComponent };